module.exports = __webpack_public_path__ + "static/media/laserbeam3.b6f30413.png";